import type { AreaPiloto } from "@/types/piloto";

interface PilotHeaderProps {
  area: AreaPiloto;
}

export default function PilotHeader({ area }: PilotHeaderProps) {
  const badges = [
    { label: `${area.municipio}/${area.uf}`, icon: "ri-map-pin-line", color: "bg-primary-100 text-primary-700 border-primary-200" },
    { label: `${area.totalQuadras} quadras`, icon: "ri-grid-line", color: "bg-accent-100 text-accent-700 border-accent-200" },
    { label: "Área Piloto", icon: "ri-flask-line", color: "bg-secondary-100 text-secondary-700 border-secondary-200" },
    { label: `Prioridade ${area.prioridadeInventario}`, icon: "ri-arrow-up-line", color: "bg-warning-100 text-warning-700 border-warning-200" },
    { label: "Infraestrutura Verde", icon: "ri-plant-line", color: "bg-primary-50 text-primary-600 border-primary-200" },
  ];

  return (
    <div className="bg-white border-b border-background-200/70 px-5 py-4 shrink-0">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-3">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1">
            <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center shrink-0">
              <i className="ri-plant-line text-white text-sm"></i>
            </div>
            <h1 className="text-lg font-bold text-foreground-900 font-heading truncate">
              FloraIQ — {area.bairro}
            </h1>
            <span className="text-[10px] font-medium px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 border border-primary-200 whitespace-nowrap">
              {area.status}
            </span>
          </div>
          <p className="text-xs text-foreground-500 max-w-2xl">
            Inventário Arbóreo Urbano e Inteligência Territorial da Arborização
          </p>
        </div>
        <div className="flex flex-wrap gap-1.5">
          {badges.map((b) => (
            <span
              key={b.label}
              className={`inline-flex items-center gap-1 text-[10px] font-medium px-2 py-1 rounded-full border whitespace-nowrap ${b.color}`}
            >
              <i className={`${b.icon} text-[10px]`}></i>
              {b.label}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}